import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'store-need-help',
  template: '@if (needHelp) {<section class="resize" [innerHTML]=needHelp></section>}',
  styleUrls: ['./need-help.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NeedHelpComponent {
  @Input() needHelp: string;
}
